import React, { Component } from 'react';

const header = () => {
  return (
    <header id="home">
      <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
        <a className="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>
        <ul id="nav" className="nav">
          <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
          <li><a className="smoothscroll" href="#about">About</a></li>
          <li><a className="smoothscroll" href="#resume">Resume</a></li>
          <li><a className="smoothscroll" href="#portfolio">portfolio</a></li>
          <li><a className="smoothscroll" href="#contact">Contact</a></li>
        </ul> {/* end #nav */}
      </nav> {/* end #nav-wrap */}
      <div className="row banner">
        <div className="banner-text">
          <h1 className="responsive-headline">Luke Simonetti</h1>
          <h2 className="responsive-headline" style={{color: '#ffffff'}}>Full Stack Software Engineer</h2>
          <h3>I'm an Atlanta based <span>software engineer</span>, <span>creative</span>, <span>musician</span>, and <span>entrepreneur</span>.
            <a className="smoothscroll" href="#about"> Start scrolling </a>
            to learn more <a className="smoothscroll" href="#about">about me</a>.
            </h3>
          <hr />
          
          <ul className="social">
            <li><a href="https://github.com/lukejsimonetti"><i className="fa fa-github" /></a></li>
            <li><a href="https://stackoverflow.com/users/3321344/lsimonetti"><i className="fa fa-stack-overflow" /></a></li>
          </ul>
        </div>
      </div>
      <p className="scrolldown">
        <a className="smoothscroll" href="#about"><i className="icon-down-circle" /></a>
      </p>
    </header>
  )
}

export default header


// WEBPACK FOOTER //
// ./src/main/header.js